var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 20.5C3 10.8383 10.8383 3 20.5 3C30.1617 3 38 10.8383 38 20.5C38 30.1617 30.1617 38 20.5 38C10.8383 38 3 30.1617 3 20.5ZM20.5 5.69231C12.3252 5.69231 5.69231 12.3252 5.69231 20.5C5.69231 28.6748 12.3252 35.3077 20.5 35.3077C28.6748 35.3077 35.3077 28.6748 35.3077 20.5C35.3077 12.3252 28.6748 5.69231 20.5 5.69231Z",
    fill: "#09984A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5157 12.332C30.0896 12.8352 30.1641 13.7288 29.682 14.3279L18.282 28.4945C18.0294 28.8085 17.6588 28.9928 17.266 28.9998C16.8733 29.0068 16.4969 28.8358 16.2341 28.531L11.3484 22.8644C10.847 22.2828 10.8922 21.3871 11.4493 20.8637C12.0064 20.3403 12.8645 20.3874 13.3659 20.969L17.2075 25.4247L27.6037 12.5055C28.0858 11.9064 28.9418 11.8287 29.5157 12.332Z",
    fill: "#09984A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmark);
export default __webpack_public_path__ + "static/media/icon-checkmark.c45b53d44ce9d20a7dfca01cecb14010.svg";
export { ForwardRef as ReactComponent };